import axios from 'axios';
import { setSpecUrls } from '@/specUrls';
import { MainProps } from '@/components/Swagger';

export interface ConfigType {
  name: string;
  url: string;
}

export default function useConfig({ type, defaultUrl }: Omit<MainProps, 'docsUrl'>) {
  const getConfig = async (domainListUrl: string) => {
    const { data } = await axios.get(domainListUrl);
    const specUrls = data[type]?.map(({ url, name }: ConfigType) => ({
      name,
      url: url.replace('../', defaultUrl),
    }));
    setSpecUrls(specUrls);
    return specUrls;
  };

  return getConfig;
}
